import userAgent from 'user-agent'

export function getExtraData () {
  const { title, URL, domain } = document || {}
  return {
    sourcePageTitle: title,
    domain,
    sourcePageUrl: URL || location.href,
    userAgent: JSON.stringify(userAgent.parse(navigator.userAgent))
  }
}
